import SoftButton from "components/SoftButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({
  open,
  onClose,
  onAccept,
  acceptButtonText,
  dialogTitle,
  dialogContent,
  acceptButtonColor,
  closeButtonVariant,
}) {
  const handleAccept = () => {
    // Call the function passed in through props
    onAccept();
    onClose();
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{dialogContent}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <SoftButton
            onClick={onClose}
            variant={closeButtonVariant ? closeButtonVariant : "outlined"}
            color="info"
          >
            {acceptButtonText == "Cancel" ? "Close" : "Cancel"}
          </SoftButton>
          {onAccept && (
            <SoftButton
              variant="contained"
              color={acceptButtonColor ? acceptButtonColor : "info"}
              onClick={handleAccept}
            >
              {acceptButtonText}
            </SoftButton>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
